<template>
	<div :class="'gallery-primary pb-8 bg-secondary-contrast px-4'" v-show="seoBannerList?.length > 0">
		<template v-if="seoBannerList?.length == 1">
			<div v-for="(slide) in seoBannerList" :key="slide?.id">
				<NuxtLink :to="slide.link" :external="true">
					<nuxt-img 
						v-if="device.isMobile" 
						densities="x1" 
						class="image-item"
						preset="categoryBannerMobile" 
						:src="slide.mobileImage"
						:title="slide.title" 
						:alt="slide.alt"
					/>
					<nuxt-img 
						v-else 
						densities="x1" 
						class="image-item" 
						preset="categoryBannerDesktop" 
						:src="slide.desktopImage"
						:title="slide.title" :alt="slide.alt"
					/>
				</NuxtLink>
			</div>
		</template>
		<template v-else>
			<NuxtCarousel v-bind="carouselConfig" class="option-line-bullets ">
				<NuxtSlide v-for="slide in seoBannerList" :key="slide?.id">
					<BasicBtErrorBoundary>
						<NuxtLink :to="slide.link" :external="true">
							<nuxt-img 
								v-if="device.isMobile" 
								densities="x1" 
								class="image-item w-full" 
								preset="categoryBannerMobile" 
								:src="slide.mobileImage"
								:title="slide.title" 
								:alt="slide.alt" />
							<nuxt-img 
								v-else 
								densities="x1" 
								class="image-item w-full" 
								preset="categoryBannerDesktop" 
								:src="slide.desktopImage"
								:title="slide.title" 
								:alt="slide.alt" />
						</NuxtLink>
					</BasicBtErrorBoundary>
				</NuxtSlide>
				<template #addons>
					<NuxtNavigation />
					<NuxtPagination />
				</template>
			</NuxtCarousel>
		</template>
	</div>
</template>

<script setup lang="ts">
import { getExpArticleCategory } from "~/composables/ExpApi/expArticle";
import { ref, toRaw } from "vue";
import { getValidSeoBanners } from "~/composables/ExpApi/expCategory";
const device = useDevice();
const props = defineProps({
	categoryId: {
		type: String,
		required: true,
		default: () => "-"
	}
})

const carouselConfig = {
	itemsToShow: 1,
	autoplay: 5000,
	gap: 24,
	breakpointMode: 'carousel',
	snapAlign: 'center',
	paginateByItemsToShow: true,
	wrapAround: true,
} as const;

const { data: banner } = props?.categoryId != "-" ? await getExpArticleCategory(props?.categoryId) : {data: undefined}

const seoBannerList = ref(getValidSeoBanners(structuredClone(toRaw(banner?.value?.contextSensitiveData?.seoBannerList?.filter(ban => ban?.position == null))), useCurrentStore().value?.id));
</script>

<style lang="postcss" scoped>
.image-item {
	margin: auto;
}
.carousel__slide > a {
	width:100%;
}
</style>